import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const animal: ImportTypeConfig = {
  type: 'animal',
}
